<script>
export default {
  name: "TheEffContractUmuTableColumnFullName",

  props: {
    fullName: {
      type: String,
      required: true,
    },

    status: {
      type: Boolean,
      required: true,
    },

    progress: {
      type: Number,
      required: true,
    },
  },

  computed: {
    isSentReview() {
      return this.status;
    },

    isNotSentReview() {
      return !this.status;
    },

    colorText() {
      if(this.isNotSentReview) return '';

      if (this.isSentReview && this.progress < 100) return 'deep-orange--text';

      if (this.isSentReview && this.progress >= 100) return 'success--text__umu';
    },

    text() {
      if(this.isNotSentReview) return 'В процессе заполнения';

      if (this.isSentReview && this.progress < 100) return 'Отправлен на проверку';

      if (this.isSentReview && this.progress >= 100) return 'ЭК проверен';
    },
  },
}
</script>

<template>
  <v-list>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title
          v-text="fullName"
        />
        <v-list-item-subtitle
          class="font-weight-bold"
          :class="colorText"
          v-text="text"
        />
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<style scoped>
  .success--text__umu {
    color: #05fa1d !important;
  }
</style>